(() => {
  'use strict';
  const dialog = document.querySelector('[data-mdl-region-dialog]');
  const controls = document.querySelectorAll('[data-mdl-region-open]');
  if (!dialog || !controls.length) return;

  const seenKey = 'mdl-region-choice-shown-v1';
  const getSeen = () => {
    try { return localStorage.getItem(seenKey) === '1'; }
    catch (_) { try { return sessionStorage.getItem(seenKey) === '1'; } catch (_) { return false; } }
  };
  const markSeen = () => {
    try { localStorage.setItem(seenKey, '1'); }
    catch (_) { try { sessionStorage.setItem(seenKey, '1'); } catch (_) {} }
  };
  const openRegion = () => {
    if (!dialog.open && !document.querySelector('dialog[open]')) dialog.showModal();
  };

  controls.forEach(trigger => trigger.addEventListener('click', () => {
    if (!dialog.open) dialog.showModal();
  }));
  dialog.querySelector('[data-mdl-region-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', markSeen);
  dialog.querySelector('form')?.addEventListener('submit', markSeen);

  // First visit: confirm destination before shopping; returning visitors use the header globe.
  if (!getSeen()) {
    window.setTimeout(() => {
      if (getSeen() || dialog.open || document.querySelector('dialog[open]')) return;
      openRegion();
    }, 1200);
  }
})();